import { defineStore } from 'pinia'
import { useApi } from '@/api/useApi'
import { useBaseStore } from '@haskoning/vue-basestore'
import API from '@/api/apiUrls'
import { isTransportStage, type MaterialDto } from './buildingBlock'

const serviceURL = API.BUILDING_BLOCK.MATERIALS.INDEX

export const useMaterialStore = defineStore('material', () => {
  const { api } = useApi()
  const baseStore = useBaseStore<MaterialDto>({ service: serviceURL, api })

  return {
    ...baseStore,
    isTransportStage
  }
})
